module.exports = __webpack_public_path__ + "static/img/banner7.a077748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner7.jpg
// module id = C4K3
// module chunks = 6